import React from "react";
// NAVIGATION
import { useNavigate, useLocation } from "react-router-dom";
// ANT DESIGN COMPONENTS
import { Breadcrumb } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

function NotificationsBreadcrumb() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");
	const navigate = useNavigate();
	const location = useLocation();
	const idBank = new URLSearchParams(location.search).get("idBank");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const navigateToBanks = () => {
		navigate({
			pathname: "/notification-management/notifications-banks",
		});
	};

	// ************************************************* */
	// USE EFFECT ************************************** */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Breadcrumb>
			<Breadcrumb.Item>{t("general.notificationManagement")}</Breadcrumb.Item>
			{idBank && idBank !== "" && (
				<Breadcrumb.Item className='generalStyles__breadcrumbItemInactive' onClick={navigateToBanks}>
					{t("general.banks")}
				</Breadcrumb.Item>
			)}
			<Breadcrumb.Item className='generalStyles__breadcrumbItem'>{t("general.notifications")}</Breadcrumb.Item>
		</Breadcrumb>
	);
}

export default NotificationsBreadcrumb;
